import React, { useState, useMemo } from 'react';
import styles from './FilterPopup.module.css';

function FilterPopup({ availableFilters, activeFilters, allProducts, onApply, onClose }) {
  const [localFilters, setLocalFilters] = useState({
    companies: [...activeFilters.companies],
    filterCategories: [...activeFilters.filterCategories],
    originalCategories: [...activeFilters.originalCategories],
  });

  const toggle = (group, value) => {
    setLocalFilters((prev) => {
      const current = prev[group];
      const updated = current.includes(value)
        ? current.filter((v) => v !== value)
        : [...current, value];

      const next = { ...prev, [group]: updated };

      // כשמשנים חברות — מסננים קטגוריות שכבר לא רלוונטיות
      if (group === 'companies') {
        const relevantProducts = next.companies.length > 0
          ? allProducts.filter((p) => next.companies.includes(p.designer))
          : allProducts;
        const validFC = new Set(relevantProducts.map((p) => p.filterCategory));
        const validOC = new Set(relevantProducts.map((p) => p.originalCategory));
        next.filterCategories = next.filterCategories.filter((c) => validFC.has(c));
        next.originalCategories = next.originalCategories.filter((c) => validOC.has(c));
      }

      return next;
    });
  };

  const clearAll = () => {
    setLocalFilters({ companies: [], filterCategories: [], originalCategories: [] });
  };

  // חישוב הקטגוריות הרלוונטיות לפי החברות שנבחרו
  const visibleFilterCategories = useMemo(() => {
    const base = localFilters.companies.length > 0
      ? allProducts.filter((p) => localFilters.companies.includes(p.designer))
      : allProducts;
    return [...new Set(base.map((p) => p.filterCategory).filter(Boolean))];
  }, [localFilters.companies, allProducts]);

  const visibleOriginalCategories = useMemo(() => {
    const base = localFilters.companies.length > 0
      ? allProducts.filter((p) => localFilters.companies.includes(p.designer))
      : allProducts;
    return [...new Set(base.map((p) => p.originalCategory).filter(Boolean))];
  }, [localFilters.companies, allProducts]);

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <span className={styles.title}>סינון</span>
          <button className={styles.closeBtn} onClick={onClose}>✕</button>
        </div>

        <div className={styles.body}>
          {availableFilters.companies.length > 1 && (
            <div className={styles.group}>
              <h3 className={styles.groupTitle}>חברה</h3>
              {availableFilters.companies.map((company) => (
                <label key={company} className={styles.option}>
                  <input
                    type="checkbox"
                    checked={localFilters.companies.includes(company)}
                    onChange={() => toggle('companies', company)}
                    className={styles.checkbox}
                  />
                  <span>{company}</span>
                </label>
              ))}
            </div>
          )}

          {visibleFilterCategories.length > 1 && (
            <div className={styles.group}>
              <h3 className={styles.groupTitle}>סוג מוצר</h3>
              {visibleFilterCategories.map((cat) => (
                <label key={cat} className={styles.option}>
                  <input
                    type="checkbox"
                    checked={localFilters.filterCategories.includes(cat)}
                    onChange={() => toggle('filterCategories', cat)}
                    className={styles.checkbox}
                  />
                  <span>{cat}</span>
                </label>
              ))}
            </div>
          )}

          {visibleOriginalCategories.length > 1 && (
            <div className={styles.group}>
              <h3 className={styles.groupTitle}>קטגוריה</h3>
              {visibleOriginalCategories.map((cat) => (
                <label key={cat} className={styles.option}>
                  <input
                    type="checkbox"
                    checked={localFilters.originalCategories.includes(cat)}
                    onChange={() => toggle('originalCategories', cat)}
                    className={styles.checkbox}
                  />
                  <span>{cat}</span>
                </label>
              ))}
            </div>
          )}
        </div>

        <div className={styles.footer}>
          <button className={styles.clearBtn} onClick={clearAll}>נקה הכל</button>
          <button className={styles.applyBtn} onClick={() => onApply(localFilters)}>החל</button>
        </div>
      </div>
    </div>
  );
}

export default FilterPopup;
